/**
 * Сборка рядов для движка расхождений.
 *
 * Движок ждёт не ленту сделок, а значение на каждом баре: накопленный
 * поток и открытый интерес, выровненные по свечам, с пустотами там, где
 * данных нет. Между биржей и движком всегда стоит это преобразование.
 *
 * Лежит в общем пакете, а не в терминале, по той же причине, по которой
 * там же лежит сам движок: график и сервер обязаны собирать ряд
 * одинаково. Разойдись они на одном баре — и появилось бы «на графике
 * линия есть, а уведомление не пришло», причём без единой ошибки в
 * журнале.
 */
/**
 * Накопленный ряд из дельты по барам: та же линия, что рисует Spot CVD.
 *
 * Пустой бар не обнуляет сумму и не разрывает её: он берёт предыдущее
 * значение. Пропуск данных — это «не знаем, сколько прибавилось», а не
 * «не прибавилось ничего», и ноль на его месте движок прочитал бы как
 * настоящую остановку потока.
 */
export function cumulativeOf(bars, points) {
    if (points.length === 0)
        return bars.map(() => null);
    const byTime = new Map(points.map((point) => [point.at, point.value]));
    let sum = null;
    return bars.map((bar) => {
        const delta = byTime.get(bar.time);
        if (delta === undefined)
            return sum;
        sum = (sum ?? 0) + delta;
        return sum;
    });
}
/**
 * Производный ряд по барам: последнее известное значение на каждом баре.
 *
 * Открытый интерес биржа публикует по своему расписанию, и оно не
 * совпадает с барами. Брать ближайшее по времени вперёд нельзя: на
 * закрытом баре это значило бы заглянуть в будущее.
 */
export function alignedOf(bars, points) {
    if (points.length === 0)
        return bars.map(() => null);
    const sorted = [...points].sort((a, b) => a.at - b.at);
    let cursor = 0;
    let value = null;
    return bars.map((bar) => {
        while (cursor < sorted.length && sorted[cursor].at <= bar.time) {
            value = sorted[cursor].value;
            cursor += 1;
        }
        return value;
    });
}
//# sourceMappingURL=divergence-input.js.map